import { useStyletron } from '@olxeu-jobs/ui';
import { forwardRef } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Link as BaseLink } from 'react-router-dom';

type Props = Omit<React.ComponentPropsWithoutRef<typeof BaseLink>, 'innerRef'> & {
  /**
   * Scroll to top of the page when the link is clicked and target is current tab. Defaults to `true`
   */
  scrollToTop?: boolean;
  target?: '_self' | '_blank';
};

export const Link = forwardRef<HTMLAnchorElement, Props>(
  ({ scrollToTop = true, onClick, className, ...props }, ref) => {
    const [css] = useStyletron();
    const classNames = [css({ color: 'inherit' }), className].filter(Boolean).join(' ');

    const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
      const targetSelf = !props.target || props.target === '_self';

      onClick?.(event);

      if (
        scrollToTop &&
        targetSelf &&
        !event.defaultPrevented &&
        !(event.metaKey || event.ctrlKey)
      ) {
        requestAnimationFrame(() => {
          window.scrollTo(0, 0);
        });
      }
    };

    return <BaseLink ref={ref} onClick={handleClick} className={classNames} {...props} />;
  },
);
